import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

import { cn } from "../utils/cn";

interface IconAmexProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

function IconAmex({ className, asChild = false }: IconAmexProps) {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 39 38"
      width="39"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.4033 38V31.9785H33.819L31.4584 29.3687L29.0865 31.9785H13.9716V19.8147H9.09316L15.1443 6.12028H20.9803L23.0635 10.8118V6.12028H30.2873L31.5413 9.6558L32.8036 6.12028H38.4033V0H0.40332V38H38.4033ZM34.5912 30.4555H38.4033L33.3607 25.1081L38.4033 19.8216H34.652L31.5375 23.2248L28.4534 19.8216H24.6405L29.6534 25.1385L24.6405 30.4555H28.3478L31.4774 27.0218L34.5919 30.4555H34.5912ZM35.4834 25.1127L38.4033 28.2196V22.0316L35.4834 25.1127ZM18.4875 27.9946V26.3386H24.4885V23.9385H18.4875V22.2824H24.6405V19.8216H15.5858V30.4562H24.6405V27.9954H18.4875V27.9946ZM35.532 18.278H38.4033V7.64332H33.9368L31.5512 14.2667L29.1815 7.64332H24.639V18.278H27.5102V10.8338L30.2447 18.278H32.7968L35.5313 10.8186V18.278H35.532ZM21.3732 18.278H24.6397L19.9452 7.64332H16.2075L11.513 18.278H14.7035L15.5851 16.1508H20.4772L21.3732 18.278ZM19.474 13.7659H16.5875L18.0308 10.2866L19.474 13.7659Z"
        fill="#006FCF"
      />
    </Comp>
  );
}

IconAmex.displayName = "IconAmex";

export { IconAmex };
